import { Separator } from '@volue/wave-react';
import type { ReactNode } from 'react';
import React, { useRef } from 'react';

import styles from './SplitView.module.css';
import { SplitViewContext } from './SplitViewContext';
import { useOpenPanelHalfway } from './useOpenPanelHalfway';
import { useSplitViewState } from './useSplitViewState';

export type SplitViewProps = {
  header?: ReactNode;
  textPanel?: ReactNode;
  mapPanel: ReactNode;
};

export function SplitView({ header, textPanel, mapPanel }: SplitViewProps) {
  const splitViewState = useSplitViewState(!!textPanel);
  const splitViewRef = useRef<HTMLDivElement | null>(null);

  useOpenPanelHalfway(textPanel, splitViewRef);

  return (
    <SplitViewContext.Provider value={splitViewState}>
      <div className="dF fdC h100 w100 ofA">
        {header && (
          <div className="fs0">
            {header}
            <Separator />
          </div>
        )}
        <div className={styles.splitWrapper}>
          <div ref={splitViewRef} className={styles.splitView}>
            <div className={styles.mapPanel}>{mapPanel}</div>
            {textPanel && (
              <div className={`${styles.textPanel} elevationXs`}>
                <div className={styles.textPanelDragger}>
                  <div />
                </div>
                <div className={styles.innerTextPanel}>{textPanel}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SplitViewContext.Provider>
  );
}
